// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__dJpO3","bigColWidth":"Table_bigColWidth__1481m","biggerColWidth":"Table_biggerColWidth__3-h7p","row":"Table_row__bCh8h","col":"Table_col__3346j"};